module.exports = __webpack_public_path__ + "portal-static/img/notice.caad7b35.png";